/* eslint-disable no-shadow */
export enum FlightType {
    charter = 1,
    regular = 2,
}